import axios from 'axios';
import { Cookies } from 'react-cookie';

const axiosClient = axios.create({
  // baseURL: 'https://api.iranhostserver.ir/',
  // baseURL: 'http://37.156.145.253/',
  // baseURL: 'https://akkapi.projectsd.ir/',
  // baseURL: 'https://atrassapi.projectsd.ir/',
  // baseURL: 'https://zebraapi.projectsd.ir/',
  baseURL: 'https://saharkhizapi.projectsd.ir/',
  // baseURL: 'https://devapi.projectsd.ir/',
  // baseURL: 'https://biniciapi.projectsd.ir/',
  // baseURL: 'http://api.symatix.ir/',
  // baseURL: 'https://akkapi.iranhostserver.ir/',
  // baseURL: 'https://zebrasiaapi.iranhostserver.ir/',
});

const cookies = new Cookies();

axiosClient.interceptors.request.use(config => {
  const token = cookies.get('token');

  config.headers = config.headers ?? {};

  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  } else {
    delete config.headers.authorization;
  }

  return config;
});

// axiosConfig.defaults.headers.post["Authorization"] = `Bearer+${s}`; // for GET requests

export default axiosClient;
